import { AUTO_HIDE_DURATION_DEFAULT, SNACKBAR_SEVERITY } from "@constants/notificationStack";
import { useSnackbar as useNotistackSnackbar } from "notistack";
import type { ShowSnackbarOptions } from "./types/types";

export const useNotificationStack = () => {
	const { enqueueSnackbar, closeSnackbar } = useNotistackSnackbar();

	const showNotification = ({
		message,
		severity = SNACKBAR_SEVERITY.INFO,
		autoHideDuration = AUTO_HIDE_DURATION_DEFAULT,
	}: ShowSnackbarOptions) => {
		enqueueSnackbar(message, {
			variant: severity,
			autoHideDuration: autoHideDuration,
		});
	};

	return {
		showSnackbar: showNotification,
		closeSnackbar,
	};
};
